import { useAppDispatch, useAppSelector } from '@/shared/lib/redux/hooks';
import { currentStoreChanged } from '@/shared/lib/redux/actions';
import { useLazyListMembershipsQuery } from '../api/authApi';

/** Re-resolves `store.currentStoreId` against the signed-in user's live memberships, picking the
 *  first one when the current selection is missing or no longer valid — the same rule
 *  `useBootstrap` applies on page load (docs/PLAN.md §6: "localStorage / единственное членство /
 *  первое"). Needed anywhere a session starts mid-SPA-lifetime without a full reload, e.g.
 *  `LoginForm`, where a stale/null `currentStoreId` (cleared by a prior logout) would otherwise
 *  send `RootRedirect`/`RequireMembership` to the wrong zone. */
export function useResolveCurrentStore() {
  const dispatch = useAppDispatch();
  const currentStoreId = useAppSelector((state) => state.store.currentStoreId);
  const [fetchMemberships] = useLazyListMembershipsQuery();

  return async () => {
    const memberships = await fetchMemberships()
      .unwrap()
      .catch(() => []);
    const stillValid = memberships.some((m) => m.storeId === currentStoreId);
    if (!stillValid) {
      dispatch(currentStoreChanged(memberships[0]?.storeId ?? null));
    }
  };
}
